<mat-form-field class="w-full" [subscriptSizing]="'dynamic'">
  <mat-label>Tipo de moneda</mat-label>
  <mat-select [formControl]="formControl">
    @for (option of options; track option) {
      <mat-option [value]="option.id">
        {{ option.text }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
